export * from './functions';
export * from './primitives/line';
export * from './primitives/plane';
export * from './primitives/ray';
export * from './curves/hermitePoint';
export * from './curves/hermiteCurve';

import * as glMatrix from 'gl-matrix';
export { glMatrix }  